export default __webpack_public_path__ + "static/media/330_portfolio02-nl-mobile.cb7e597f.png";